import React, { FC } from 'react';

import Portal from '../../../../ui/Portal';
import HelpIcon from '../../../../ui/icons/Help';

import styles from './styles.module.scss';

type UnavailableProps = {
	title: string;
	description?: string | null;
};

const Unavailable: FC<UnavailableProps> = ({ title, description }) => {
	return (
		<Portal
			destroyOnInteract={true}
			parentNodeSelector={styles.unavailableIcon}
			tooltipLabel={
				<div className={styles.unavailable}>
					<div className={styles.unavailableTitle}>{title}</div>
					{description && (
						<div className={styles.unavailableIcon}>
							<HelpIcon />
						</div>
					)}
				</div>
			}>
			{description && <div className={styles.unavailableText}>{description}</div>}
		</Portal>
	);
};

export default Unavailable;
